import React from 'react';

import Information from './Information';

function Vilseledande() {
  return (
    <Information
      head={
        <div>
          <span>
            {'Regelverk om att information inte får vara vilseledande'}
          </span>
          <i>{'EU-förordning 1169/2011. Artikel 7'}</i>
          <small>{'Rättvisande information'}</small>
        </div>
      }
    >
      <p>
        {`
          1. Livsmedelsinformation får inte vara vilseledande, i synnerhet
        `}
      </p>
      <ol type="a">
        <li>
          <strong>
            {`
              när det gäller vad som är utmärkande för livsmedlet, särskilt
              dess art, identitet, egenskaper,  sammansättning, kvantitet,
              hållbarhet, ursprungsland eller härkomstplats, framställnings-
              eller produktionsmetod
            `}
          </strong>
        </li>
        <li>
          {`
            genom att livsmedlet tillskrivs verkningar eller egenskaper
            som det inte har,
          `}
        </li>
        <li>
          {`
            genom att det antyds att livsmedlet har speciella egenskaper,
            då i själva verket alla liknande livsmedel har sådana egenskaper,
            framför allt genom att närvaron eller frånvaron av vissa
            ingredienser och/eller näringsämnen särskilt framhävs,
          `}
        </li>
        <li>
          {`
            genom att det genom utseendet, beskrivningen eller genom
            presentationer i bild antyds att produkten innehåller ett särskilt
            livsmedel eller en ingrediens trots att en beståndsdel som
            normalt förekommer naturligt eller en ingrediens som normalt
            används i det livsmedlet har bytts ut mot en annan beståndsdel
            eller ingrediens,
          `}
        </li>
      </ol>
      <p>
        {`
          2. Livsmedelsinformation ska vara korrekt, tydlig och lätt att förstå
          för konsumenten.
        `}
      </p>
      <p>
        {`
          3. Om inte annat följer av undantag i unionsrätten för naturliga
          mineralvatten och livsmedel för särskilda näringsändamål, får
          livsmedelsinformation inte tillskriva livsmedel egenskapen att
          förebygga, behandla eller bota mänskliga sjukdomar eller hänvisa
          till sådana egenskaper.
        `}
      </p>
      <p>{'4. Punkterna 1, 2 och 3 ska även tillämpas på'}</p>
      <ol type="a">
        <li>{'reklam,'}</li>
        <li>
          {`
            presentationen av livsmedel, särskilt med avseende på deras form,
            utseende eller förpackning, de förpackningsmaterial som används
            och det sätt på vilket livsmedlen arrangeras samt den miljö i
            vilken de exponeras.
          `}
        </li>
      </ol>
    </Information>
  );
}

export default Vilseledande;



// WEBPACK FOOTER //
// ./src/components/Information/Vilseledande.js